//
//
//
//
//
//

const TYPES = {
    '意向客户': 'intention',
    '无效客户': 'invalid',
    '到访客户': 'vist',
    '潜在客户': 'hidden',
}
export default {
    props: {
        client_mark: String
    },
    computed: {
        type_class() {
            return TYPES[this.client_mark]
        },
    }
}
